export default __webpack_public_path__ + "img/img_stephen-47cb1a7cf1c25da1b9f4a98c821b7f7a.jpg";